import { api, apiTest } from './config'
import { getToken, setToken, removeToken } from '../store/auth'
import request from './request'
var sha1 = require('sha1'); 

export default {
  administrador: {
    retornarServico (id) {
      console.log(id)
      // return api.get('/retornarServicos/'+id)
      return request({
        url: '/retornarServicos/' + id,
        method: 'get'
      })
    },

    retornarDashboard () {
      // return api.get(`administradorEmpresa/retornarDashboard/${idEmpresa}`)
      return request({
        url:'/administradorEmpresa/retornarDashboard/',
        method: 'get'
      })
    },

    alterarNomeUnidade (idUnidade, nomeUnidade) {
      var obj = {
        idUnidade: idUnidade,
        nomeUnidade: nomeUnidade
      }
      // return api.post('/administradorEmpresa/alterarNomeUnidade',obj)
      return request({
        url:'/administradorEmpresa/alterarNomeUnidade/',
        method: 'post',
        data: obj
      })
    },
    

    alterarNomeUnidadeEtiqueta (idUnidade, nomeUnidadeEtiqueta) {
      var obj = {
        idUnidade: idUnidade,
        nomeUnidadeEtiqueta: nomeUnidadeEtiqueta
      }
      // return api.post('/administradorEmpresa/alterarNomeUnidade',obj)
      return request({
        url:'/administradorEmpresa/alterarNomeUnidadeEtiqueta/',
        method:'post',
        data: obj
      })
    },

    desativarFuncionario (username, tipo) {
      // console.log(id);
      var obj = {
        username: username,
        tipo: tipo
      }
      // return api.post('administradorEmpresa/desativarFuncionario',obj)
      return request({
        url: '/administradorEmpresa/desativarFuncionario/',
        method: 'post',
        data: obj
      })
    },

    ativarFuncionario (username, tipo) {
      // console.log(id);
      var obj = {
        username: username,
        tipo: tipo
      }
      // return api.post('administradorEmpresa/ativarFuncionario',obj)
      return request({
        url: '/administradorEmpresa/ativarFuncionario/',
        method: 'post',
        data: obj
      })
    },

    cadastrarAdministrador (password, username, idUnidade, nome) {
      // console.log(id);
      var obj = {
        password: sha1(password),
        username: username,
        idUnidade: idUnidade,
        nome: nome
      }
      // return api.post('/administradorEmpresa/cadastrarAdministrador',obj)
      return request({
        url: '/administradorEmpresa/cadastrarAdministrador/',
        method: 'post',
        data: obj
      })
    },

    retornarAdministradores () {
      // console.log(id);
      // return api.get('/administradorEmpresa/retornarAdministradores/'+idEmpresa)
      return request({
        url: '/administradorEmpresa/retornarAdministradores/',
        method: 'get'
      })
    },

    retornarUnidades () {
      // return api.get('/administradorEmpresa/retornarUnidades/'+idEmpresa)
      return request({
        url: '/administradorEmpresa/retornarUnidades/',
        method: 'get'
      })
    },

    cadastrarUnidade (nomeUnidade) {
      //  console.log(id);
      var obj = {
        nomeUnidade: nomeUnidade
      }
      // return api.post('/administradorEmpresa/cadastrarUnidade',obj)
      return request({
        url: '/administradorEmpresa/cadastrarUnidade',
        method: 'post',
        data: obj
      })
    },

    excluirAdministrador (username) {
      console.log(username)
      var obj = {
        username: username
      }
      // return api.post('/administradorEmpresa/excluirAdministrador',obj)
      return request({
        url: '/administradorEmpresa/excluirAdministrador/',
        method: 'post',
        data: obj
      })
    },

    alterarSenha (senhaAtual, novaSenha, tipo, username) {
      var obj = {
        senhaAtual: sha1(senhaAtual),
        novaSenha: sha1(novaSenha),
        username: username,
        tipo: tipo
      }
      // return api.post('/administradorEmpresa/alterarSenha',obj)
      return request({
        url: '/administradorEmpresa/alterarSenha/',
        method: 'post',
        data: obj
      })
    },

    alterarNomeAdministrador (novoNome, username, tipo) {
      console.log('alterar')

      var obj = {
        nome: novoNome,
        username: username,
        tipo: tipo
      }
      // return api.post('/administradorEmpresa/alterarNome',obj)
      return request({
        url: '/administradorEmpresa/alterarNomeAdministrador/',
        method: 'post',
        data: obj
      })
    },

    alterarAdministradorUnidade (idUnidade, nome, username) {
      var obj = {
        idUnidade: idUnidade,
        nome: nome,
        username: username
      }
      // return api.post('/administradorEmpresa/alterarAdministradorUnidade',obj)
      return request({
        url: '/administradorEmpresa/alterarAdministradorUnidade/',
        method: 'post',
        data: obj
      })
    }
  }
}
